import { render, staticRenderFns } from "./infoAccessRecoveryPage.vue?vue&type=template&id=4b15cfcb&scoped=true"
import script from "./infoAccessRecoveryPage.vue?vue&type=script&lang=js"
export * from "./infoAccessRecoveryPage.vue?vue&type=script&lang=js"
import style0 from "./infoAccessRecoveryPage.vue?vue&type=style&index=0&id=4b15cfcb&prod&lang=scss&scoped=true"
import style1 from "./infoAccessRecoveryPage.vue?vue&type=style&index=1&id=4b15cfcb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b15cfcb",
  null
  
)

export default component.exports